import React, { FC } from 'react';
import { useTranslationAPI } from '../../../../translations';
import shareModuleCodes from '../../../../../data/translations/shareModuleCodes';
import { PublicJobDetailShareButtons } from './PublicJobDetailShareButtons';
import { PublicJobDetailUnderlinedSection } from '../PublicJobDetailUnderlinedSection';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { Helmet } from 'react-helmet';

export const PublicJobDetailShare: FC = () => {
	const { translate } = useTranslationAPI();
	const {
		data: { openGraphTags },
	} = usePublicJobDetailDataQuery();

	return (
		<PublicJobDetailUnderlinedSection title={translate(shareModuleCodes.common.share)}>
			<Helmet meta={openGraphTags} />
			<PublicJobDetailShareButtons />
		</PublicJobDetailUnderlinedSection>
	);
};
